/**
 * Outils partagés des images utilisateur (signature LS-685, tampons LS-689),
 * utilisés par ImageUtilisateurUploader et TamponsManager.
 */

const MAX_SIZE_OCTETS = 5 * 1024 * 1024;
const ACCEPTED_TYPES = ["image/png", "image/jpeg"];

/**
 * Contrôle client d'un fichier d'image utilisateur, aligné sur les règles API
 * (PNG/JPEG, 5 Mo). Renvoie le message d'erreur à afficher, ou null si valide.
 */
export const validerImageUtilisateur = (file) => {
  if (!ACCEPTED_TYPES.includes(file.type)) {
    return "Format non pris en charge : PNG ou JPEG uniquement.";
  }
  if (file.size > MAX_SIZE_OCTETS) {
    return "Le fichier dépasse la taille maximale de 5 Mo.";
  }
  return null;
};

/**
 * Fusionne dans le user du store la réponse d'une route image/tampon.
 *
 * Ces routes répondent une UserResource hors route `me` : `role` y est un objet
 * `{ id, name }` (et non la chaîne attendue par tous les tests de rôle) et
 * `permissions` est absent. Remplacer le user du store par cette réponse
 * casserait l'UI de droits jusqu'au rechargement — on ne prend que les champs
 * d'images, le reste garde sa forme de bootstrap.
 */
export const fusionnerImagesUtilisateur = (userCourant, reponse = {}) => ({
  ...userCourant,
  signatureUrl:
    reponse.signatureUrl !== undefined
      ? reponse.signatureUrl
      : (userCourant.signatureUrl ?? null),
  tampons:
    reponse.tampons !== undefined ? reponse.tampons : userCourant.tampons || [],
});
